import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntitySubmissionDetailsComponent } from './entity-submission-details.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModuleMobi } from '../material/material.module';
import { MatNativeDateModule } from '@angular/material/core';
import { AppPermissionsPipe, SharedModule, } from 'shared-library';
import { EntityEntriesTableComponent } from './entity-entries-table/entity-entries-table.component';



@NgModule({
  declarations: [EntitySubmissionDetailsComponent,EntityEntriesTableComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModuleMobi,
    MatNativeDateModule,
    SharedModule,
    AppPermissionsPipe
  ],
  exports: [EntitySubmissionDetailsComponent,EntityEntriesTableComponent]
})
export class EntitySubmissionDetailsModule { }
